<template lang="pug">
  form.b-register-form(@submit.prevent="submit" autocomplete="off")
    h1._title Регистрация пользователя
    ._content
      BaseField._item(
        v-for="(field, name) in fields"
        v-model="field.value"
        v-bind="field"
        :key="name"
        :name="name"
        autocomplete="new-password"
        @change="inputChanged(name);"
        )
    BaseCheckbox._checkbox-wrap(
      v-for="(checkbox, name) in checkboxes"
      v-model="checkbox.value"
      v-bind="checkbox"
      :key="name"
      @change="checkboxChanged(name);"
    )
    Btn(green submit)._register-btn Зарегистрироваться
</template>

<script>
import api from '@/api/user';
import preRegisterApi from '@/api/preRegister';
import form from '@/utils/form';
import Cookies from 'js-cookie';

import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseField from '@/components/BaseField.vue';
import CommonRange from '@/components/CommonRange.vue';
import user from '@/model/user';

export default {
  name: 'AuthRegisterForm',
  components: { BaseCheckbox, CommonRange, BaseField }, // eslint-disable-line
  data() {
    return {
      userId: null,
      user: null,
      /* eslint-disable */
      checkboxes: {
        policyConfirmed:  form.createFieldObject('checkbox', 'Я принимаю условия <a href="/policy" target="_blank">Политики конфиденциальности</a> и даю своё согласие на обработку персональных данных', false, { required: 'Это поле обязательно' }),
        licenceConfirmed: form.createFieldObject('checkbox', 'Я принимаю условия <a href="/agreement" target="_blank">лицензионного соглашения</a>', false, { required: 'Это поле обязательно' }),
      },
      fields: {
        name:           form.createFieldObject('text',      'Имя',              '', { required: 'Укажите имя'                                      } ),
        surname:        form.createFieldObject('text',      'Фамилия',          '', { required: 'Укажите фамилию'                                  } ),
        email:          form.createFieldObject('email',     'E-mail',           '', { required: 'Укажите E-mail',   email: 'Почта некорректна'     } ),
        phone:          form.createFieldObject('tel',       'Телефон',          '', {                                                              } ),
        password:       form.createFieldObject('password',  'Пароль',           '', { required: 'Укажите пароль'                                   } ),
        repeatPassword: form.createFieldObject('password',  'Повторите пароль', '', { required: 'Повторите пароль'                                 } ),
      },
      /* eslint-enable */
    };
  },
  methods: {
    inputChanged(fieldName) {
      form.validateField(this.fields, fieldName);
    },
    checkboxChanged(fieldName) {
      form.validateField(this.checkboxes, fieldName);
    },
    submit() {
      form.validate(this.fields);
      form.validate(this.checkboxes);

      const formHasErrors = form.hasErrors(this.fields) || form.hasErrors(this.checkboxes);
      const passwordsAreNotEqual = this.fields.password.value !== this.fields.repeatPassword.value;

      if (passwordsAreNotEqual) {
        this.fields.repeatPassword.error = 'Пароли не совпадают';
      }

      if (passwordsAreNotEqual || formHasErrors) {
        return;
      }

      const formData = form.getValues(this.fields);

      if (!formData.phone.trim()) {
        formData.phone = null;
      }

      delete formData.repeatPassword;

      const affiliateCode = Cookies.get('affiliate');
      if (affiliateCode) {
        formData.affiliateCode = affiliateCode;
      }

      api.create(formData)
        .then(() => { this.$emit('register'); })
        .catch((e) => {
          const errors = {
            'This value is already used.': {
              phone: 'Пользователь с таким телефоном уже существует',
              email: 'Пользователь с таким e-mail уже существует',
            },
          };

          // eslint-disable-next-line no-unused-expressions
          e?.violations?.forEach(({ propertyPath, message }) => {
            const field = this.fields[propertyPath];

            if (!field) {
              return;
            }

            field.error = errors?.[message]?.[propertyPath] ?? 'Неизвестная ошибка';
          });
        });
    },
  },
  mounted() {
    const email = this.$route?.query?.email;
    const name = this.$route?.query?.name;

    this.fields.email.value = email;
    this.fields.name.value = name;

    if (email || name) {
      preRegisterApi.create({ email, name });
    }

    const codeFromParam = this.$route.params.affiliateCode;
    if (codeFromParam) {
      Cookies.set('affiliate', codeFromParam, { expires: 365 });
    }
  },
  created() {
    if (this.$store.state.auth.user) {
      this.$router.push('/');
      return;
    }

    user.fetchSelf().then(() => { this.$router.push('/'); });
  },
};
</script>

<style scoped lang="scss">
.register-form {
  display: block;

  &__content {
    display: grid;
    column-gap: 36px;
    row-gap: 16px;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 26px;
  }

  &__item {
    min-width: 286px;
  }

  &__checkbox-wrap {
    margin-bottom: 20px;
    max-width: 374px;
    text-align: left;
  }

  &__title {
    font-weight: 700;
    color: var(--color-dark-gray);
    line-height: 20px;
    font-size: 20px;
    margin-bottom: 30px;
  }

  @media (max-width: 768px) {
    &__content {
      column-gap: 24px;
    }
  }

  @media (max-width: 576px) {
    &__checkbox-wrap {
      margin-bottom: 30px;
    }
  }

  @media (max-width: 576px) {
    &__content {
      grid-template-columns: 1fr;
    }

    &__register-btn {
      width: 100%;
    }
  }
}
</style>
